<template>
  <card>
    <div slot="header">
      <h4 class="title">Profile Setup</h4>
    </div>
    <div>
      <form autocomplete="off"> 

        <br>
        <h5>User:</h5>
        <hr>
        <div class="row">
          <div class="col-md-5">
            <fg-input type="text"
                      label="First Name"
                      :disabled="false"
                      placeholder="First name"
                      required
                      v-model="affiliateUser.firstName">
           </fg-input>
          </div>
          <div class="col-md-7">
            <fg-input type="text"
                      label="Last Name"
                      placeholder="Last name"
                      required
                      v-model="affiliateUser.lastName">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-7">
            <fg-input type="email"
                      label="Email (username)"
                      autocomplete="off"
                      placeholder="Personal email address"
                      required
                      v-model="affiliateUser.email">
           </fg-input>
          </div>
          <div class="col-md-5">
            <fg-input type="password"
                      label="Password"
                      autocomplete="new-password"
                      :placeholder="$store.getters.userStatus == 'pending' ? '8+ characters' : 'hidden' "
                      :disabled="$store.getters.userStatus == 'pending' ? false : true"
                      v-model="affiliateUser.password"
                      :required="$store.getters.userStatus == 'pending' ? true : false"
                      v-tooltip.top-center="$store.getters.userStatus == 'pending' ? '' : 'To change your password, please contact our Support team'">
            </fg-input>
          </div>
        </div>
        <br><br>

        <h5>Company:</h5>
        <hr>
        
        <div class="row">
          <div class="col-md-11">
            <label>Company: </label> &nbsp; {{ affiliateCompany.profile ? affiliateCompany.profile.companyName : '' }}
          </div>
        </div>

        <div class="row">
          <div class="col-md-11">
            <label> Work email: </label> &nbsp; <small>{{ affiliateUser.email2 }} </small>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Position"
                      placeholder="Position at your company"
                      required
                      v-model="affiliateUser.position">
           </fg-input>
          </div>
        </div>

        <br><br>
        <h5>Home address:</h5>
        <hr>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Home address Line 1"
                      placeholder="Home address line 1"
                      required
                      v-model="affiliateUser.address.addressLine1">
           </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Home address Line 2"
                      placeholder="Home address line 2"
                      v-model="affiliateUser.address.addressLine2">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <fg-input type="text"
                      label="Country"
                      placeholder="Country"
                      required
                      v-model="affiliateUser.address.country">
            </fg-input>
          </div>
          <div class="col-md-4">
            <fg-input label="Province"
                      required>
              <el-select v-model="affiliateUser.address.state" class="removeReadonly">
                <el-option
                  v-for="item in statesProvinces"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </fg-input>
          </div>
          <div class="col-md-4">
            <fg-input type="text"
                      label="City"
                      placeholder="City"
                      required
                      v-model="affiliateUser.address.city"/>
          </div>
        </div>

        <div class="row">
          
          <div class="col-md-4">
            <fg-input label="Postal Code"
                      placeholder="Postal Code"
                      required
                      v-model="affiliateUser.address.postalCode">
            </fg-input>
          </div>
          <div class="col-md-3">
            <fg-input label="Timezone"
                      required>
              <el-select v-model="affiliateUser.timezoneOffset" class="removeReadonly">
                <el-option v-for="timezone in timezones"
                           :key="timezone.value"
                           :label="timezone.label"
                           :value="timezone.value"
                           @keyup.enter="save()"/>
              </el-select>
            </fg-input>
          </div>
          <div class="col-md-5">
            <fg-input type="text"
                      label="Mobile Phone"
                      placeholder="Personal mobile phone"
                      required
                      v-model="affiliateUser.phone">
            </fg-input>
          </div>
        </div>

        <br><br>
        <div class="text-center">
          <button type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="save">
            Save
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>

<script>
export default {
  name: 'Profile-Setup',
  data () {
    return {
      affiliateUser: {
        firstName:        this.$store.getters.affiliateUser.firstName,
        lastName:         this.$store.getters.affiliateUser.lastName,
        email:            this.$store.getters.affiliateUser.email,
        password:         this.$store.getters.affiliateUser.password, // shouldn't this be removed??
        email2:           this.$store.getters.affiliateUser.email2,
        position:         this.$store.getters.affiliateUser.position,
        phone:            this.$store.getters.affiliateUser.phone,
        timezoneOffset:   this.$store.getters.affiliateUser.timezoneOffset,
        address: {
          addressLine1:     this.$store.getters.affiliateUser.address.addressLine1,
          addressLine2:     this.$store.getters.affiliateUser.address.addressLine2,
          country:          this.$store.getters.affiliateUser.address.country,
          state:            this.$store.getters.affiliateUser.address.state,
          city:             this.$store.getters.affiliateUser.address.city,
          postalCode:       this.$store.getters.affiliateUser.address.postalCode
        }
      },
      affiliateCompany: this.$store.getters.affiliateCompany,
      statesProvinces: [
        { value: 'AB', label: 'AB' },
        { value: 'BC', label: 'BC' },
        { value: 'MB', label: 'MB' },
        { value: 'NB', label: 'NB' },
        { value: 'NL', label: 'NL' },
        { value: 'NU', label: 'NU' },
        { value: 'NS', label: 'NS' },
        { value: 'NT', label: 'NT' },
        { value: 'ON', label: 'ON' },
        { value: 'PE', label: 'PE' },
        { value: 'QC', label: 'QC' },
        { value: 'SK', label: 'SK' },
        { value: 'YT', label: 'YT' }
      ],
      months: [
        { value: 'january', label: 'January'},
        { value: 'february', label: 'February'},
        { value: 'march', label: 'March'},
        { value: 'april', label: 'April'},
        { value: 'may', label: 'May'},
        { value: 'june', label: 'June'},
        { value: 'july', label: 'July'},
        { value: 'august', label: 'August'},
        { value: 'september', label: 'September'},
        { value: 'october', label: 'October'},
        { value: 'november', label: 'November'},
        { value: 'december', label: 'December'},
      ],
      timezones: [
        { value: -4, label: 'Eastern Time' },
        { value: -5, label: 'Central Time' },
        { value: -6, label: 'Mountain Time' },
        { value: -7, label: 'Pacific Time' },
      ]
    }
  },
  methods: {
    async save () {
      const res = await this.$store.dispatch('saveAffiliateUser', this.affiliateUser)
      if (res.errors) {
        if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else {
        // if this is the first account save (= activation), we give extra instructions
        if (this.$store.getters.affiliateUser.status == 'pending' && !this.$store.getters.paymentCard) {
          this.$notify({
            timeout: 20000,
            successMessage: `Saved!<br><br>You will receive your card shortly.<br>`
                          + `Once received, go to Setup > Card to link it to your account.`
          })
        }
        else { // otherwise we save
          this.$notify({ successMessage: 'Saved!'})
          if (this.$store.getters.affiliateUser.status == 'pending') {
            // for password resets, we force the users to login again so that chrome saves the password
            // this.$router.go()
            this.$router.push('/login')
          }
        }
        this.$store.dispatch('fetchBaseData')
      }
    }
  }
}
</script>

<style>

</style>